<!-- src/components/kb_workspace/DeployTaskCenter.vue -->
<template>
  <div class="deploy-task-center">
    <!-- 任务列表 -->
    <div class="task-list" :style="{ width: showDetail ? '45%' : '100%' }">
      <a> 为避免影响AI客服的正常工作，系统将在空闲时处理您的发布请求。请不要频繁发布。</a>
      <el-table 
        :data="taskList" 
        stripe 
        v-loading="loading"
        @row-click="handleTaskClick"
        highlight-current-row>
        <el-table-column prop="taskId" label="任务ID" width="250" show-overflow-tooltip>
                      <template slot-scope="scope">
            <span  style="display: block; width: 100%; text-align: center;cursor: pointer;">
              {{ scope.row.taskId }}
           </span>     
        </template>
    </el-table-column>
        <el-table-column prop="mainWorkspaceSlug" label="知识库" width="150" show-overflow-tooltip >
           <template slot-scope="scope">
              <span style="display: block; width: 100%; text-align: center;cursor: pointer;">
                {{ getWorkspaceText(scope.row.mainWorkspaceSlug) }}
              </span>
            </template>         
            </el-table-column>
        <el-table-column label="状态" width="180">
          <template slot-scope="scope">
            <span style="display: block; width: 100%; text-align: center;cursor: pointer;">
              <el-tag :type="getStatusType(scope.row.status)" size="small">                
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="文档处理进度" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.totalDocs && scope.row.totalDocs > 0"  style="display: block; width: 100%; text-align: center;cursor: pointer;">
              {{ scope.row.processedDocs || 0 }} / {{ scope.row.totalDocs }}
              </span>   
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="耗时" width="100">
          <template slot-scope="scope">
           <span  style="display: block; width: 100%; text-align: center;cursor: pointer;">
              {{ formatDuration(scope.row) }}
           </span>
          </template>
        </el-table-column>
        <el-table-column prop="last_updated_at" label="起止时间" width="260" >
          <template slot-scope="scope">
            <span  style="display: block; width: 100%; text-align: center;cursor: pointer;">
              {{ formatToBeijingTime(scope.row.createTime)+'~'+formatToBeijingTime(scope.row.finishTime) }}
           </span>     
        </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button 
              v-if="scope.row.status === 'FAILED'" 
              type="text" 
              size="small"
              @click.stop="handleRetry(scope.row)">
              重试
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total" />
    </div>
    
    <!-- 任务详情面板（右侧） -->
    <div class="task-detail" v-if="showDetail && selectedTask">
      <div class="detail-header">
        <p>任务详情</p>
        <i @click="closeDetail" title="隐藏详情">
         <svg t="1778254842205" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7205" width="16" height="16"><path d="M0 0m146.285714 0l731.428572 0q146.285714 0 146.285714 146.285714l0 731.428572q0 146.285714-146.285714 146.285714l-731.428572 0q-146.285714 0-146.285714-146.285714l0-731.428572q0-146.285714 146.285714-146.285714Z" fill="#4391FF" p-id="7206"></path><path d="M512 659.382857L266.971429 375.076571a26.697143 26.697143 0 0 0-38.473143-2.048 29.184 29.184 0 0 0-2.194286 40.228572l260.461714 302.299428a29.110857 29.110857 0 0 0 7.168 9.289143c5.193143 4.534857 11.702857 6.582857 18.066286 6.509715a26.624 26.624 0 0 0 18.944-7.314286 29.110857 29.110857 0 0 0 6.290286-8.484572l260.388571-302.226285a29.184 29.184 0 0 0-2.925714-41.033143 26.697143 26.697143 0 0 0-37.741714 2.779428L512 659.382857z" fill="#FFFFFF" p-id="7207"></path></svg>
        </i>
      </div>
      
      <div class="detail-content">
        <!-- 基本信息 -->
        <el-descriptions :column="1" border size="small">
          <el-descriptions-item label="任务ID">
            <el-tooltip :content="selectedTask.taskId" placement="top">
              <span>{{ selectedTask.taskId }}</span>
            </el-tooltip>
          </el-descriptions-item>
          <el-descriptions-item label="知识库">{{ selectedTask.mainWorkspaceSlug }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="getStatusType(selectedTask.status)">
              {{ getStatusText(selectedTask.status) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ formatToBeijingTime(selectedTask.create_time) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="开始时间">{{ formatToBeijingTime(selectedTask.startTime) || '-' }}</el-descriptions-item>
          <el-descriptions-item label="完成时间">{{ formatToBeijingTime(selectedTask.finishTime) || '-' }}</el-descriptions-item>
            <el-descriptions-item label="报错信息">{{ getStatusText(selectedTask.errorMessage) || '-' }}</el-descriptions-item>
        </el-descriptions>

        
        <!-- 进度详情 -->
        <div class="progress-section" v-if="selectedTask.totalDocs > 0">
          <div class="progress-label">
            <span>文档发布进度</span>
            <span>{{ selectedTask.processedDocs || 0 }} / {{ selectedTask.totalDocs }}</span>
          </div>
          <el-progress 
            :percentage="progressPercent" 
            :status="getProgressStatus()"
            :color="progressColor" />
          
          <!-- 当前处理的文档 -->
          <div v-if="isRunning && selectedTask.currentDocName" class="current-doc">
            <i class="el-icon-loading"></i>
            <span>当前处理: {{ truncateText(selectedTask.currentDocName, 40) }}</span>
          </div>
        </div>
        
        <!-- 各阶段耗时 -->
        <div class="stage-costs" v-if="hasStageCosts">
          <div class="cost-item">
            <span>清空绿环境</span>
            <span>{{ formatMs(selectedTask.cleanCostMs) }}</span>
          </div>
          <div class="cost-item">
            <span>上传文档</span>
            <span>{{ formatMs(selectedTask.uploadCostMs) }}</span>
          </div>
          <div class="cost-item">
            <span>验证环境</span>
            <span>{{ formatMs(selectedTask.verifyCostMs) }}</span>
          </div>
          <div class="cost-item">
            <span>切换环境</span>
            <span>{{ formatMs(selectedTask.switchCostMs) }}</span>
          </div>
        </div>
        
        <!-- 错误信息 -->
        <el-alert 
          v-if="selectedTask.errorMessage" 
          :title="selectedTask.errorMessage"
          type="error"
          :closable="false"
          show-icon />
        
        <!-- 操作按钮 -->
        <div class="detail-actions">
          <el-button 
            v-if="selectedTask.status === 'FAILED'" 
            type="primary" 
            size="small"
            @click="handleRetry(selectedTask)">
            重试任务
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { 
  getDeployTaskList, 
  getDeployTaskDetail, 
  retryDeployTask 
} from '@/api/aics/deploy';
import { listKbWorkspaces_by_tenantId } from '@/api/aics/kbWorkspace';
import {formatToBeijingTime }         from '@/util/date'
export default {
  name: 'DeployTaskCenter',
  props: {
    tenantId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      taskList: [],
      total: 0,
      pageNum: 1,
      pageSize: 8,
      loading: false,
      showDetail: false,
      selectedTask: null,
      pollingTimer: null,

      workspacelist: null
    }
  },
  computed: {
    progressPercent() {
      if (!this.selectedTask || !this.selectedTask.totalDocs || this.selectedTask.totalDocs === 0) return 0;
      return Math.round((this.selectedTask.processedDocs || 0) / this.selectedTask.totalDocs * 100);
    },
    progressColor() {
      if (this.selectedTask?.status === 'FAILED') return '#f56c6c';
      if (this.progressPercent === 100) return '#67c23a';
      return '#409eff';
    },
    isRunning() {
      const runningStatus = ['PENDING', 'CLEANING', 'UPLOADING', 'VERIFYING', 'SWITCHING'];
      return this.selectedTask && runningStatus.includes(this.selectedTask.status);
    },
    hasStageCosts() {
      if (!this.selectedTask) return false;
      return (this.selectedTask.cleanCostMs && this.selectedTask.cleanCostMs > 0) ||
             (this.selectedTask.uploadCostMs && this.selectedTask.uploadCostMs > 0) ||
             (this.selectedTask.verifyCostMs && this.selectedTask.verifyCostMs > 0) ||
             (this.selectedTask.switchCostMs && this.selectedTask.switchCostMs > 0);
    }
  },
  methods: {
    formatToBeijingTime(value){
      return formatToBeijingTime(value)
    },    
    /**
     * 加载任务列表
     */
    async loadTaskList() {
      if (!this.tenantId) return;
      
      this.loading = true;
      try {
        const res = await getDeployTaskList(this.tenantId, {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        });
        console.log("getDeployTaskList", res)
        if (res.code === 200 && res.data.rows) {
          this.taskList = res.data.rows || [];
          this.total = res.data.total || 0;
          
          // 如果当前选中的任务还在列表中，更新其信息
          if (this.selectedTask && this.selectedTask.taskId) {
            const updated = this.taskList.find(t => t.taskId === this.selectedTask.taskId);
            if (updated) {
              this.selectedTask = updated;
            }
          }
        }
      } catch (error) {
        console.error('加载任务列表失败:', error);
        this.$message.error('加载任务列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    /**
     * 选中任务并加载详情
     */
    async handleTaskClick(row) {
      this.selectedTask = row;
      this.showDetail = true;
      
      // 如果任务还在运行中，启动轮询刷新详情
      if (this.isRunning) {
        await this.loadTaskDetail();
        this.startPollingDetail();
      } else {
        await this.loadTaskDetail();
        this.stopPollingDetail();
      }
    },
    
    /**
     * 加载任务详情
     */
    async loadTaskDetail() {
      if (!this.selectedTask || !this.selectedTask.taskId) return;
      
      try {
        const res = await getDeployTaskDetail(this.selectedTask.taskId);
        if (res.code === 200 && res.data) {
          this.selectedTask = res.data;
        }
      } catch (error) {
        console.error('加载任务详情失败:', error);
      }
    },
    
    /**
     * 外部调用：选中指定任务
     */
    // DeployTaskCenter.vue 中修改 selectTask 方法
    async selectTask(taskId) {
    if (!taskId) return;
    
    // 1. 先通过详情接口获取任务信息，立即显示详情
    try {
        const res = await getDeployTaskDetail(taskId);
        if (res.code === 200 && res.data) {
        // 立即显示详情（不依赖列表）
        this.handleTaskClick(res.data);
        }
    } catch (error) {
        console.error('获取任务详情失败:', error);
    }
    
    // 2. 刷新列表，并尝试选中该任务
    await this.loadTaskList();
    
    // 3. 在列表中查找并高亮
    const taskInList = this.taskList.find(t => t.taskId === taskId);
    if (taskInList) {
        // 如果已经在列表中，更新选中的任务（保持详情面板内容一致）
        this.selectedTask = taskInList;
    } else if (this.taskList.length > 0) {
        // 如果列表有数据但没找到，可能是分页问题
        // 提示用户去第一页查找
        if (this.pageNum !== 1) {
        this.pageNum = 1;
        await this.loadTaskList();
        const taskInFirstPage = this.taskList.find(t => t.taskId === taskId);
        if (taskInFirstPage) {
            this.selectedTask = taskInFirstPage;
        }
        }
    }
    },
    
    /**
     * 开始轮询刷新任务详情
     */
    startPollingDetail() {
      if (this.pollingTimer) clearInterval(this.pollingTimer);
      
      this.pollingTimer = setInterval(async () => {
        if (!this.selectedTask || !this.selectedTask.taskId) return;
        
        try {
          const res = await getDeployTaskDetail(this.selectedTask.taskId);
          if (res.code === 200 && res.data) {
            // 计算进度是否变化
            const oldProcessed = this.selectedTask.processedDocs || 0;
            const newProcessed = res.data.processedDocs || 0;
            const oldStatus = this.selectedTask.status;
            const newStatus = res.data.status;
            
            this.selectedTask = res.data;
            
            // 如果任务完成或失败，停止轮询并刷新列表
            if (newStatus === 'SUCCESS' || newStatus === 'FAILED') {
              this.stopPollingDetail();
              this.loadTaskList();
              
              // 提示用户
              if (newStatus === 'SUCCESS') {
                this.$notify({
                  title: '发布完成',
                  message: `任务 ${this.selectedTask.taskId} 已成功完成`,
                  type: 'success'
                });
              } else if (newStatus === 'FAILED') {
                this.$notify({
                  title: '发布失败',
                  message: `任务 ${this.selectedTask.taskId} 执行失败`,
                  type: 'error'
                });
              }
            } else if (oldProcessed !== newProcessed || oldStatus !== newStatus) {
              // 进度有更新，刷新列表中的对应项
              this.loadTaskList();
            }
          }
        } catch (error) {
          console.error('轮询任务详情失败:', error);
        }
      }, 3000);
    },
    
    /**
     * 停止轮询
     */
    stopPollingDetail() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    
    /**
     * 关闭详情面板
     */
    closeDetail() {
      this.showDetail = false;
      this.selectedTask = null;
      this.stopPollingDetail();
    },
    
    /**
     * 重试任务
     */
    async handleRetry(task) {
      try {
        await this.$confirm(`确定要重试任务 ${task.taskId} 吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        const res = await retryDeployTask(task.taskId);
        if (res.code === 200) {
          this.$message.success('重试已发起');
          this.loadTaskList();
          
          // 如果详情面板是打开的，刷新详情
          if (this.selectedTask && this.selectedTask.taskId === task.taskId) {
            await this.loadTaskDetail();
            this.startPollingDetail();
          }
        } else {
          this.$message.error(res.message || '重试失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('重试失败:', error);
          this.$message.error('重试失败');
        }
      }
    },
    
    /**
     * 格式化耗时
     */
    formatDuration(task) {
      if (!task.startTime) return '-';
      const start = new Date(task.startTime);
      const end = task.finishTime ? new Date(task.finishTime) : new Date();
      const diff = end - start;
      
      if (diff < 60000) return `${Math.round(diff / 1000)}秒`;
      return `${Math.round(diff / 60000)}分钟`;
    },
    
    /**
     * 格式化毫秒
     */
    formatMs(ms) {
      if (!ms || ms === 0) return '-';
      if (ms < 1000) return `${ms}ms`;
      if (ms < 60000) return `${(ms / 1000).toFixed(1)}秒`;
      return `${Math.round(ms / 60000)}分钟`;
    },
    
    /**
     * 获取状态类型（用于 el-tag）
     */
    getStatusType(status) {
      const map = {
        'PENDING': 'info',
        'CLEANING': 'warning',
        'UPLOADING': 'warning',
        'VERIFYING': 'warning',
        'SWITCHING': 'warning',
        'SUCCESS': 'success',
        'FAILED': 'danger'
      };
      return map[status] || 'info';
    },
    
    /**
     * 获取状态文本
     */
    getStatusText(status) {
      const map = {
        'PENDING': '等待中',
        'CLEANING': '清空中',
        'UPLOADING': '上传中',
        'VERIFYING': '验证中',
        'SWITCHING': '切换中',
        'SUCCESS': '成功',
        'FAILED': '失败'
      };
      return map[status] || status;
    },

    /**
     * 
     * @param slug 获取工作区名称
     */
    getWorkspaceText(slug){
        if(this.workspacelist == null)
          return "-";
        for(var i=0;i<this.workspacelist.length;i++){
            if(this.workspacelist[i].slug == slug)
              return this.workspacelist[i].name;
        }
        return '';
    },
    
    /**
     * 获取进度条状态
     */
    getProgressStatus() {
      if (this.selectedTask?.status === 'FAILED') return 'exception';
      if (this.progressPercent === 100) return 'success';
      return '';
    },
    
    /**
     * 截断文本
     */
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },
    
    /**
     * 分页大小变化
     */
    handleSizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.loadTaskList();
      this.closeDetail();
    },
    
    /**
     * 页码变化
     */
    handleCurrentChange(page) {
      this.pageNum = page;
      this.loadTaskList();
      this.closeDetail();
    }
  },
  mounted() {
    listKbWorkspaces_by_tenantId(this.tenantId).then( res=>{
        this.workspacelist = res.data;
        console.log("listKbWorkspaces_by_tenantId",this.workspacelist);
  });
        

    this.loadTaskList();
  },
  beforeDestroy() {
    this.stopPollingDetail();
  },
  watch: {
    tenantId: {
      handler(newVal) {
        if (newVal) {
          this.pageNum = 1;
          this.loadTaskList();
          this.closeDetail();
        }
      }
    }
  }
}
</script>

<style scoped>
.deploy-task-center {
  display: flex;
  gap: 20px;
  min-height: 500px;
  max-height: 600px;
}

.task-list {
  flex-shrink: 0;
  overflow-y: auto;
  transition: width 0.3s ease;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

.task-detail {
  flex: 1;
  border-left: 1px solid #e4e7ed;
  padding-left: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;
}

.detail-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.detail-header i {
  cursor: pointer;
  font-size: 18px;
  color: #909399;
}

.detail-header i:hover {
  color: #409eff;
}

.detail-content {
  flex: 1;
  overflow-y: auto;
}

.progress-section {
  margin: 16px 0;
}

.progress-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 12px;
  color: #606266;
}

.current-doc {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  gap: 6px;
}

.stage-costs {
  margin: 16px 0;
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
}

.cost-item {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  line-height: 28px;
}

.cost-item span:first-child {
  color: #606266;
}

.cost-item span:last-child {
  color: #303133;
  font-weight: 500;
}

.detail-actions {
  margin-top: 20px;
  text-align: center;
}

/* 暗色主题适配 */
@media (prefers-color-scheme: dark) {
  .task-detail {
    border-left-color: #3c3c3c;
  }
  
  .detail-header {
    border-bottom-color: #3c3c3c;
  }
  
  .stage-costs {
    background: #2a2a2a;
  }
  
  .cost-item span:first-child {
    color: #b0b0b0;
  }
  
  .cost-item span:last-child {
    color: #e5e5e5;
  }
}
</style>